import * as z from 'zod';

export const CreateTicketValidation = z.object({
  subject: z
    .string()
    .optional()
    .refine(
      (val) => !val || val.trim() === '' || val.trim().length <= 40,
      'عنوان تیکت حداکثر باید 40 کاراکتر باشد'
    ),
  description: z
    .string()
    .min(2, 'متن پیام باید حداقل 2 کاراکتر باشد')
    .max(3000, 'متن پیام نباید بیشتر از 3000 کاراکتر باشد'),
});
